import "../../App.css";
import "./Documents.css";

const Documents = () =>{

    return(
        <div className="documents">
            <div className="container">
                <h1>Dokumenty na stiahnutie</h1>

                <h2>Cenník a financovanie</h2>

                <div className="card">
                    <ul id="cen">
                            <li><a href="downloads/cennik.pdf" target="_blank">Cenník</a></li>
                            <li><a href="downloads/samoplatca.pdf" target="_blank">Kalkulačný list pre samoplatcov</a></li>
                            <li><a href="downloads/zazmluvneny.pdf" target="_blank">Kalkulačný list pre zazmluvnených klientov</a></li>
                            <li><a href="downloads/eon.pdf" target="_blank">Výška ekonomicky oprávnených nákladov</a></li>
                    </ul>
                </div>

                <h2>Ostatné dokumenty</h2>
                <div className="card">
                    <ul>
                        {/* <li><a href="downloads/ziadost_o_posudenie.pdf" target="_blank" rel = "noopener noreferrer">Žiadosť o posúdenie odkázanosti na sociálnu službu</a></li> */}
                        <li><a href="downloads/ziadost_o_uzatvorenie_zmluvy_o_poskytovani_socialnej_sluzby.pdf" target="_blank" rel = "noopener noreferrer">Žiadosť o uzatvorenie zmluvy o poskytovaní sociálnej služby</a></li>
                        <li><a href="downloads/vyrocna_sprava_2024.pdf" target="_blank" rel = "noopener noreferrer">Výročná správa za rok 2024</a></li>
                        <li><a href="downloads/strategicka_vizia.pdf" target="_blank" rel = "noopener noreferrer">Strategická vízia</a></li>
                        <li><a href="downloads/krizovy_plan_pandemia.pdf" target="_blank" rel = "noopener noreferrer">Krízový plán</a></li>
                        <li><a href="downloads/informacne_a_oznamovacie_povinnosti.pdf" target="_blank" rel = "noopener noreferrer">Informačné a oznamovacie povinnosti</a></li>
                        <li><a href="downloads/domaci_poriadok.pdf" target="_blank" rel = "noopener noreferrer">Domáci poriadok</a></li>
                        <li><a href="downloads/informacny_letak.pdf" target="_blank" rel = "noopener noreferrer">Informačný leták</a></li>
                        <li><a href="downloads/reklamny_letak.pdf" target="_blank" rel = "noopener noreferrer">Reklamný leták</a></li>
                        <li><a href="downloads/zmluva_s_prijimatelom.pdf" target="_blank" rel = "noopener noreferrer">Zmluva s prijímateľom</a></li>
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default Documents;